// An exception-free JSON.parse, returns null on invalid json (and swallows parse errors)
// inferred return type is any|null
export default (str: string) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
};
